import ReactDOM from "react-dom/client";

// scroll bar
import "simplebar-react/dist/simplebar.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "assets/third-party/apex-chart.css";
import "assets/third-party/react-table.css";

// google-fonts
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";

import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";

import "@fontsource/public-sans/400.css";
import "@fontsource/public-sans/500.css";
import "@fontsource/public-sans/600.css";
import "@fontsource/public-sans/700.css";

import { ConfigProvider } from "contexts/ConfigContext";
import App from "./App";

// import * as Sentry from "@sentry/react";

// Sentry.init({
//   dsn: "https://994315125ae0cf76ec063bdaa9c1373a@o4507870605344768.ingest.us.sentry.io/4508652568903680",
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//   ],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
//   tracePropagationTargets: [
//     // "localhost",
//     // /^http:\/\/localhost:5000\/admin/,
//     // /^http:\/\/localhost:5173/,
//     /^https:\/\/library\.gnums\.co\.in\/admin/,
//     /^https:\/\/demodlib\.gnums\.co\.in/,
//   ],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <>
    <ConfigProvider>
      <App />
    </ConfigProvider>
  </>
);
